module.exports = __webpack_public_path__ + "static/media/LoggedOn.f6785734.png";